"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var owa_bundling_1 = require("owa-bundling");
var lazyModule = new owa_bundling_1.LazyModule(function () {
    return System.import(/* webpackChunkName: "Lightning" */ './lazyIndex');
});
var store_1 = require("./store/store");
exports.store = store_1.store;
exports.beginLightning = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.beginLightningImp; });
exports.endLightning = new owa_bundling_1.LazyAction(lazyModule, function (m) { return m.endLightningImp; });
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-lightning-core/lib/index.js
// module id = 1622
// module chunks = 2 47 105 106 107